const COLLAPSED_HEIGHT = "46px";
const HEIGHT_PADDING_OFFSET = 4;
const SCROLL_TOP_THRESHOLD_PERCENTAGE = 0.05;
const SCROLL_IGNORE_TIMEOUT = 300;
const DOM_UPDATE_DELAY = 0;
export {
  COLLAPSED_HEIGHT,
  DOM_UPDATE_DELAY,
  HEIGHT_PADDING_OFFSET,
  SCROLL_IGNORE_TIMEOUT,
  SCROLL_TOP_THRESHOLD_PERCENTAGE
};
